import React, { useState } from 'react'
import CustomLinesEllipsis from '../Mydata/CustomLinesEllipsis.js'
import moment from 'moment'
import user from "../../assets/img/user.png";
import { useNavigate } from 'react-router-dom';
import Api from '../../Api.js';
import { toast } from 'react-toastify';

export default function AgentElement({element, onDelete}) {
    const navigate = useNavigate()
    const [isDeleting, setIsDeleting] = useState(false)

    const handleNavigate = (id) => {
        navigate(`/main_employee/agent-task/${id}`)
    }

    const handleDelete = async (e) => {
        e.stopPropagation(); // Prevent navigation when clicking delete
        
        if (!window.confirm('Վստա՞հ եք, որ ցանկանում եք ջնջել այս առաջադրանքը:')) {
            return;
        }

        setIsDeleting(true);
        try {
            await Api.deleteAgentTask(element.id);
            toast.success('Առաջադրանքը հաջողությամբ ջնջվեց');
            if (onDelete) {
                onDelete(element.id);
            }
        } catch (error) {
            console.error('Delete error:', error);
            toast.error(error?.response?.data?.error || 'Չհաջողվեց ջնջել առաջադրանքը');
        } finally {
            setIsDeleting(false);
        }
    }

  return (
    <div onClick={() =>handleNavigate(element.id) } className='recommendations-item card' style={{backgroundColor:element?.is_payed ? '#afffaf85' : '#f0f0f0', height:300, position: 'relative'}}>
        <div className="recommendations-item-cont">
                <div className="card-overflow">
                    <div className="recommendations-item-top">
                        <div className='recommendations-item-heading'>
                            {element?.title}
                        </div>
                        {!element.assigned_to && localStorage.getItem('profession') !== 'agent' && (
                            <button 
                                onClick={handleDelete}
                                disabled={isDeleting}
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    background: '#dc3545',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    padding: '5px 10px',
                                    cursor: isDeleting ? 'not-allowed' : 'pointer',
                                    fontSize: '12px',
                                    zIndex: 10
                                }}
                            >
                                {isDeleting ? 'Ջնջվում է...' : 'Ջնջել'}
                            </button>
                        )}
                    </div>
                    <div className='recommendations-item-text'>
                        <CustomLinesEllipsis text={element?.description} maxLines={2}/>
                        <div>Պատասխանատու - {element.assigned_to? `${element.assigned_to?.user?.first_name} ${element.assigned_to?.user?.last_name}`: `Նշված չէ`}</div>
                        <div>Տեսակ - {element.task_type? `${element.task_type?.name}`: `Նշված չէ`}</div>
                        <div>Գին - {element.purchases_total? `${element.purchases_total}`: `Նշված չէ`}</div>
                        <div>Կից ֆայլեր - {element.files_count? `${element.files_count}`: `Նշված չէ`}</div>
                        
                        {/* <div className="process-file-message">
                            <div>{item?.approved === 0?"Դիտարկվում է":item?.approved === 1?'Հաստատված է':"Մերժված է"}</div>
                            <div className="recommendations-item-text-icon-cont"/>
                        </div> */}
                        {/* <div>{item?.is_sent === 1?'Փոխանցված':''}</div> */}

                    </div>
                    <div className='recommendations-item-bottom'>
                        <hr/>
                        <div className='image-calendar'>
                            <div className="image-name-emplayee">
                                <img alt="img" className='task-image' src={element?.company?.logo || user}/>
                                <span
                                    className="name-emplayee"
                                    title={element?.company?.name || ""}
                                >
                                    {element?.company?.name 
                                        ? element.company.name.length > 10 
                                            ? `${element.company.name.substring(0, 10)}...` 
                                            : element.company.name
                                        : ""
                                    }
                                </span> 
                            </div>
                            <span className='calendar'>
                            <span className='icon-Calendar'/>
                            <div className="task-date-cont">
                                <span className='moment'>Ստղ. {element?.created_at ? moment(element?.created_at).format('LLL') : null}</span> 
                                {/* <span className='moment'>Day off սկիզբ {item?.start_date ? moment(item?.start_date).format('LLL') : null}</span> */}
                                {/* <span className='moment'>Day off ավարտ {item?.end_date ? moment(item?.end_date).format('LLL') : null}</span> */} 
                            </div>
                        </span>
                        </div>
                        

                    </div>

                </div>
            </div>


    </div>
  )
}
